













































































































































































import Vue from 'vue';
import Component from 'vue-class-component';
import Patientele from '../components/Patientele';
import RemuSocle from '../components/RemuSocle';
import RemuOption from '../components/RemuOption';
import Resultat from '../components/Resultat';
import { mdiChevronLeft } from '@mdi/js';

@Component({
	components: {
		Patientele,
		RemuSocle,
		RemuOption,
		Resultat
	}
})
export default class Simulation extends Vue {
	$refs!: Vue['$refs'] & {
		patientele: Patientele,
		remuSocle: RemuSocle,
		remuOption: RemuOption,
		resultat: Resultat
	};

	chevronLeft = mdiChevronLeft;
	isAfkModalVisible = false;
	stepperValue = 0;
	timerInSeconds = 10800;
	timerModal = 120;
	isModalForLeaveOpen = false;

	tabs = [
		{
			label: 'Patientèle de référence',
			disabled: false
		},
		{
			label: 'Rémunérations Socle',
			disabled: true
		},
		{
			label: 'Rémunérations Optionnelles',
			disabled: true
		},
		{
			label: 'Vos résultats',
			disabled: true
		}
	];

	openLeaveModal(): void{
		this.isModalForLeaveOpen = true;
	}

	updateValue(index: number): void {
		this.stepperValue = index;

		if(index === 1) {
			this.$refs.patientele.addObjectToStore();
		}else if (index ===  2) {
			this.$refs.remuSocle.addObjectToStore();
		}else if (index === 3) {
			this.$refs.remuOption.addObjectToStore();
		}
	}

	// Méthodes
	activateTab(tabNum: number, isValid: boolean): void {
		if(true == isValid) {
			this.tabs[tabNum].disabled = false;
		} else {
			this.tabs[tabNum].disabled = true;
		}
	}

	async goToFirstStep(): Promise<void>{
		await this.$store.dispatch('mspRemuOptionnel/clearData');
		await this.$store.dispatch('mspRemuSocle/clearData');
		await this.$store.dispatch('mspPatientele/clearData');
		this.$router.go(0);
	}

	afkModalTrigger(): void {
		this.isAfkModalVisible = true;
		this.timerInSeconds = 10800;
		this.reduceModalTimer();
	}

	reduceSessionTimer(): void {
		const sessionInterval = setInterval(()=> {
			if (this.timerInSeconds === 0 || this.timerInSeconds < 0) {
				this.afkModalTrigger();
				clearInterval(sessionInterval);
			}
			this.timerInSeconds --;
		}, 1000);
	}

	reduceModalTimer(): void {
		const modalInterval = setInterval(()=> {
			if (this.timerModal === 0 || this.timerModal < 0) {
				this.isAfkModalVisible = true;
				clearInterval(modalInterval);
				this.goToFirstStep();
			}
			this.timerModal --;
		}, 1000);
	}

	cancelTimer(): void {
		this.isAfkModalVisible = false;
		this.timerInSeconds = 10800;

	}

	created(){
		this.reduceSessionTimer();
	}
}
